import VideoShareView from 'v/VideoShare/VideoShareView';

export default {
  state() {
    return {};
  },

  getters: {},

  // @params state, payload
  mutations: {},

  // @param context {{state, rootState, commit, dispatch, getters, rootGetters}}
  // @param payload
  actions: {
    sendToCMS(context, storyId) {
      return app.api.producedStories.sendStoryToCMS({ storyId });
    },
    connectYoutube: function ({ dispatch }, { story, onDisplayOpen }) {
      const promise = new _.ColdPromise();
      app.videoController
        .connectToYoutube(story)
        .then(() => {
          onDisplayOpen && onDisplayOpen();
          dispatch('displayShare', { provider: 'youtube', story })
            .then((props) => {
              app.videoController
                .uploadToYoutube(
                  props.storyModel,
                  props.title,
                  props.description,
                  props.privacyStatus
                )
                .then(promise.resolve, promise.reject);
            })
            .catch(promise.reject);
        })
        .fail(promise.reject);
      return promise;
    },
    connectTwitter: function ({ dispatch }, { story, onDisplayOpen }) {
      const promise = new _.ColdPromise();
      app.videoController
        .connectToTwitter(story)
        .then(() => {
          onDisplayOpen && onDisplayOpen();
          dispatch('displayShare', { provider: 'twitter', story })
            .then((props) => {
              app.videoController
                .uploadToTwitter(
                  props.storyModel,
                  props.title,
                  props.description
                )
                .then(promise.resolve, promise.reject);
            })
            .catch(promise.reject);
        })
        .fail(promise.reject);
      return promise;
    },
    connectFacebook: function ({ dispatch }, { story, onDisplayOpen }) {
      const promise = new _.ColdPromise();
      app.videoController
        .connectToFaceBook(story)
        .then(() => {
          onDisplayOpen && onDisplayOpen();
          dispatch('displayShare', { provider: 'facebook', story })
            .then((props) => {
              app.videoController
                .uploadToFaceBook(
                  props.storyModel,
                  props.title,
                  props.description,
                  props.targetId
                )
                .then(promise.resolve, promise.reject);
            })
            .catch(promise.reject);
        })
        .fail(promise.reject);
      return promise;
    },
    displayShare: function (context, { story, provider }) {
      const promise = new _.ColdPromise();
      const storyModel = new Backbone.Model(story);
      const shareView = new VideoShareView({
        provider,
        model: storyModel,
      });

      app.controller.showViewInModal(shareView);

      storyModel.listenToOnce(shareView, 'share:upload', function (e) {
        promise.resolve({
          storyModel,
          title: e.title,
          description: e.description,
          targetId: e.targetId,
          privacyStatus: e.privacyStatus,
        });
      });

      storyModel.listenToOnce(shareView, 'share:close', promise.reject);

      return promise;
    },
  },
};
